import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import Constants from 'utils/Constants';
import styles from 'styles/components/headers/printHeader.css';

const PrintHeader = props => {
  let { productionName , reportPeriod, unit } = props;
  let firstDay = 'FirstDay';
  let lastDay = 'End Day';
  let tableDay = 'Table Day';
  if (reportPeriod) {
    firstDay = moment(reportPeriod.firstDay, "x").format('MMM DD YYYY');
    lastDay = moment(reportPeriod.lastDay, "x").format('MMM DD YYYY');
  }
  if (props.selectedView === Constants.view.table) {
    tableDay = moment(props.tableDate).format('MMM DD YYYY')
    return (
      <header className={styles.printHeader}>
        <div className={styles.container}>
          <h3 className={styles.title}>{productionName ? productionName : ''}</h3>
          <p className={styles.subtitle}>
            Daily Report for {tableDay}
          </p>
        </div>
      </header>
    );
  } else {
    return (
      <header className={styles.printHeader}>
        <div className={styles.container}>
          <h3 className={styles.title}>{productionName ? productionName : ''}</h3>
          <p className={styles.subtitle}>
            {unit} Sales Report Period <span className={styles.subtitleEm}>{` ${firstDay} - ${lastDay}`}</span>
          </p>
        </div>
      </header>
    );
  }
};

PrintHeader.propTypes = {
  productionName: PropTypes.string,
  reportPeriod: PropTypes.object
}

export default PrintHeader;



// WEBPACK FOOTER //
// ./src/scripts/components/headers/PrintHeader.js